import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class VehicleAvailability extends _BaseUserProfile {
  component = 'YesNoSelection';
  props = {
    title: 'Do You Have a Reliable, Well-Maintained Vehicle / ' +
    'Truck to Drive to and From Oilfield Jobs?',
    errorMessage: 'Please Answer on Question',
    additionalFormInModal: true,
    modalTitle: 'Add Information About Your Vehicle',
    additionalFormComponent: 'VehicleInfoForm',
  };
  skipConditionsExists = true;
  skipConditions = {
    value: false,
    stepToGo: 13,
  };
  jumpedFrom = 2;
}
